import React from 'react';

function About() {
  return (
    <div className="page">
      <h2>About</h2>
      <p>This is the about page.</p>
    </div>
  );
}

export default About;
